import axios from 'axios'

// Get all ticket types
const getAll = async () => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/ticket-type`)
  return data
}

// Get ticket type by id
const get = async (id) => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/ticket-type/${id}`)
  return data
}

// Create ticket type
const create = async (
  name,
  desc,
  percentage,
  def,
  sell,
  special = false
) => {
  const { data } = await axios.post(`${process.env.VUE_APP_API}/ticket-type`, {
    name,
    desc,
    percentage,
    default: def,
    sell,
    special
  })
  return data
}

// Update ticket type
const update = async (
  id,
  name,
  desc,
  percentage,
  def,
  sell,
  special = false
) => {
  const { data } = await axios.put(`${process.env.VUE_APP_API}/ticket-type/${id}`, {
    name,
    desc,
    percentage,
    default: def,
    sell,
    special
  })
  return data
}

// Remove ticket type
const remove = async (id) => {
  const { data } = await axios.delete(`${process.env.VUE_APP_API}/ticket-type/${id}`)
  return data
}

export {
  getAll,
  get,
  create,
  update,
  remove
}
